import { httpPost, httpPut } from './request'

export const logout = () => {
  return httpPost({
    url: '/ikg/logout',
  })
}

export const editPwd = (data: any) => {
  return httpPut({
    url: '/ikg/user/editpwd',
    data,
  })
}
